import { applyMiddleware, createStore } from 'redux'
import { createLogger } from 'redux-logger'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import createRootReducer from './rootReducer'

// middleware
// ----------------------------------------------------------------------------
export const history = createBrowserHistory()

const middleware = [
  routerMiddleware(history)
]

if (process.env.NODE_ENV !== 'production') {
  const logger = createLogger({
    collapsed: () => true,
  })
  middleware.push(logger)
}

// store
// ----------------------------------------------------------------------------
const configureStore = () => {
  const rootReducer = createRootReducer()
  const store = createStore(rootReducer, applyMiddleware(...middleware))

  return { store }
}

export default configureStore
